import { Component } from "@angular/core";

import { NavParams, MenuController, NavController } from "ionic-angular";
import { APIServiceProvider } from "../../../common/services/api.service";

import { CashnotsubmittedPage } from "../cashnotsubmitted/cashnotsubmitted";
import { SettlementPendingPage } from "../settlementpending/settlementpending";
import { CashsettledPage } from "../cashsettled/cashsettled";
import { NotifyService } from "../../../services/notify.service";
import { HelperServiceProvider } from "../../../common/services/helper.service";

@Component({
  selector: "tabs-delivered",
  templateUrl: "tabs-delivered.html"
})
export class TabDelivered {
  // set the root pages for each tab
  cashnotsubmittedPage = CashnotsubmittedPage;
  settlementPendingPage = SettlementPendingPage;
  cashsettledPage = CashsettledPage;

  public cashSubmittedUrl = "orders/cash-submitted-order-total";
  public settlementPendingUrl = "orders/cash-not-submitted-order-total";
  public cashSubmitedTotal = 0;
  public cashNotSubmitedTotal = 0;
  public settlementPendingTotal = 0;

  public cashSubmitedLbl = "Cash Settled (₹) " + this.cashSubmitedTotal;

  mySelectedIndex: number = 0;

  constructor(
    navParams: NavParams,
    public helperService: HelperServiceProvider,
    public menu: MenuController,
    public navCtrl: NavController,
    public apiService: APIServiceProvider,
    private notifyService: NotifyService
  ) {
    //this.getTotals();

    this.notifyService.cashSubmitted.subscribe(() => {
      //this.getTotals();
    });

    this.notifyService.orderDelivered.subscribe(() => {
      //this.getTotals();
    });
  }

  getTotals() {
    const cashSubmittedParams: any = {
      dispatched_to: localStorage.getItem("manager_user_id"),
      order_status: 4,
      settlement_status: 1,
      from_user_id: localStorage.getItem("manager_user_id")
    };
    const cashNotSubmittedParams: any = {
      dispatched_to: localStorage.getItem("manager_user_id"),
      order_status: 4,
      settlement_status: -1,
      from_user_id: localStorage.getItem("manager_user_id")
    };
    const settlementPendingParams = {
      to_user_id: localStorage.getItem("manager_user_id")
    };
    this.apiService
      .post(this.cashSubmittedUrl, cashSubmittedParams)
      .subscribe(data => {
        this.cashSubmitedTotal = data["data"];
      });
    this.apiService
      .post(this.cashSubmittedUrl, cashNotSubmittedParams)
      .subscribe(data => {
        this.cashNotSubmitedTotal = data["data"];
      });
    this.apiService
      .post(this.settlementPendingUrl, settlementPendingParams)
      .subscribe(data => {
        this.settlementPendingTotal = data["data"];
      });
  }

  ionViewDidLoad() {
    this.menu.enable(true);
  }
  ionViewWillEnter(){
    this.notifyService.orderDelivered.next("refresh api");
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/orderdeliveredtabs/tabs-delivered.ts